import CardSelectItem from "./CardSelectItem";

const CardSelector = ({
  cards,
  paymentMethod,
  removeCard,
  setCurrentSource,
  name,
}) => {
  const setSource = (source) => {
    setCurrentSource(() => source);
  };
  return (
    <div>
      {(cards || [])
        .filter((e) => e) // filter nulls
        .map((entry) => (
          <CardSelectItem
            key={entry.id}
            id={entry.id}
            name={name}
            card={entry.card}
            checked={entry.id === paymentMethod}
            needsUpdate={entry.needsUpdate}
            setSource={setSource}
            onRemove={removeCard}
          />
        ))}{" "}
      <CardSelectItem
        new
        name={name}
        id="new"
        key="new"
        setSource={setSource}
        checked={paymentMethod === "new"}
      />{" "}
    </div>
  );
};

export default CardSelector;
